export const frequencyConversion = {
  monthly: "month",
  quarterly: "quarter",
  yearly: "year",
};
